import React from 'react';

import { ModalButtonType } from '@philips-emr/tws-constants';
import { ModalService } from '@philips-emr/tws-core/lib/services';

import './dialog-service.scss';

class DialogServiceAccreditation {

  static confirm(dialogDescription: string): Promise<void> {
    return new Promise((resolve, reject) => ModalService.openDialog({
      title: 'pa.warning',
      closeable: false,
      className: 'tws-dialog-service dialog-confirm',
      dialogDescription,
      dockButtons: [
        {
          title: 'pa.close',
          type: ModalButtonType.CANCEL,
          action: reject,
        },
        {
          title: 'pa.ok',
          type: ModalButtonType.SUCCESS,
          action: resolve,
        },
      ],
    }));
  }

  static alert(dialogDescription: string): Promise<void> {
    return new Promise((resolve) => ModalService.openDialog({
      title:'pa.warning',
      closeable: false,
      children: (<div style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: dialogDescription }} />),
      dockButtons: [
        {
          title: 'pa.ok',
          type: ModalButtonType.SUCCESS,
          action: resolve,
        },
      ],
    }));
  }
}

export {
  DialogServiceAccreditation,
};
